'use strict';

$(document).ready(function () {
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $giftCertPin = $('input[name$=_giftCertPin]');
    var $giftbalance = $('#gift-balance');
    var $form = $('#gift-form');
    var $resetForm = $('#gift-reset-form');
    var $balance = $('.showerror');
    var $error = $('#gift-form-error');
    $('#check-giftcert').on('click', function () {
        var $balance = $('.balance');
        var gift_giftCertCode = $('#gift_giftCertCode').val();
        var gift_giftCertPin = $('#gift_giftCertPin').val();
        var url = $('.giftcertificate-balance').data('url');

        if (!gift_giftCertCode || !gift_giftCertCode) {
            var error = $balance.find('span.error');
            if (error.length === 0) {
                error = $('<span>').addClass('error').appendTo($balance);
            }
            error.html(Resources.GIFT_CERT_MISSING);
            return;
        }

        $.ajax({
            type: 'POST',
            url: url,
            data: { gift_giftCertCode: gift_giftCertCode, gift_giftCertPin: gift_giftCertPin },
            success: function success(data) {
                if (!data.success) {
                    $balance.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('error');
                    return;
                } else {
                    $error.hide();
                    $balance.html('');
                    $giftCertPin.removeClass('error');
                    $giftCertCode.removeClass('error');
                    $form.hide().removeClass('form-error');
                    $giftbalance.find('.card-value .value').html(data.ID);
                    $giftbalance.find('.balance').html(data.balance).removeClass('error').addClass('success');
                    $giftbalance.show();
                }
            }
        });
    });

    $resetForm.on('click', function (e) {
        e.preventDefault();
        $balance.hide();
        $error.hide();
        $giftCertPin.removeClass('error');
        $giftCertCode.removeClass('error');
        $form.find('#gift_giftCertCode').val('');
        $form.find('#gift_giftCertPin').val('');
        $form.find('label, .input-text').removeClass('float');
        $form.show();
    });
});
